import { duration } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import LoadingView from "../../LoadingView/LoadingView";
export const OptionsLoadingView = styled(LoadingView) `
  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  opacity: 0;
  animation: fade-in ${duration.animation.slow}ms ease;
  animation-fill-mode: forwards;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3B0aW9uc0xvYWRpbmdWaWV3LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2VsZWN0L3N0eWxlZC9PcHRpb25zTG9hZGluZ1ZpZXcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQzFFLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sV0FBVyxNQUFNLCtCQUErQixDQUFDO0FBRXhELE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLE1BQU0sQ0FBQyxXQUFXLENBQUMsQ0FBQTs7Ozs7Ozs7Ozs7dUJBVzlCLFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSTs7Q0FFN0MsQ0FBQyJ9